<template>
  <svg :class="svgClass" aria-hidden="true" v-on="$listeners" :style="{width: svgWidth, height: svgHeight}">
    <use :xlink:href="iconName"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 1
    },
    height: {
      type: [Number, String],
      default: 1
    }
  },
  computed: {
    svgWidth() {
      if (typeof this.width === 'number') {
        return `${this.width}em`
      }
      return this.width
    },
    svgHeight() {
      if (typeof this.height === 'number') {
        return `${this.height}em`
      }
      return this.height
    },
    iconName() {
      return `#icon-${this.name}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      }
      return 'svg-icon'
    }
  }
}
</script>

<style scoped>
.svg-icon {
  /* width: 2em;
  height: 2em; */
  vertical-align: -0.15em;
  fill: currentColor !important;
  overflow: hidden;
}
</style>
